import { render, staticRenderFns } from "./ImportSpreadsheet.vue?vue&type=template&id=08bf90f2&"
import script from "./ImportSpreadsheet.vue?vue&type=script&lang=js&"
export * from "./ImportSpreadsheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VFileInput,VIcon,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bf90f2')) {
      api.createRecord('08bf90f2', component.options)
    } else {
      api.reload('08bf90f2', component.options)
    }
    module.hot.accept("./ImportSpreadsheet.vue?vue&type=template&id=08bf90f2&", function () {
      api.rerender('08bf90f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/ImportSpreadsheet.vue"
export default component.exports